import React from "react";
import { Typography } from "components";
import { isArray } from "../utils/helper";
import { PropTypes } from "prop-types";

const BeadCrumb = ({ titles, ...rest }) => {
  if (!isArray(titles)) return "";

  return (
    <div className="beadcrumb" {...rest}>
      {titles
        .filter((title, index) => index !== titles.length - 1)
        .map((title, key) => (
          <Typography component="span" variant="body4" state="grey" key={key}>
            {title} / {" "}
          </Typography>
        ))}
      <Typography
        component="span"
        variant="body4"
        state="secondary"
        style={{ marginLeft: "6px" }}
        className="text-underline"
      >
        {titles[titles.length - 1]}
      </Typography>
    </div>
  );
};

BeadCrumb.propTypes = {
  titles: PropTypes.array.isRequired,
};

export default BeadCrumb;
